<section class="cambio">
	<div class="cambio-header fondo-blue"></div>
	<section class="cambio-form">
		<div class="cambio-form-image">
			<img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy">
		</div>
		<div class="cambio-form-content">
			<input [(ngModel)]="newCuenta.password" type="password" placeholder="Ingresa tu nueva contraseña">
		</div>
		<div class="cambio-form-content">
			<input [(ngModel)]="newCuenta.confirmar" type="password" placeholder="Confirma tu nueva contraseña">
		</div>
		<div class="cambio-form-content-controls">
			<button (click)="fnVerificarClaves()" class="cambio-form-content-button fondo-purple">
				Cambiar contraseña
			</button>
		</div>
	</section>
</section>